import { render, staticRenderFns } from "./LimitedTimeOfferEditor.vue?vue&type=template&id=10cf2b0f&scoped=true"
import script from "./LimitedTimeOfferEditor.vue?vue&type=script&lang=js"
export * from "./LimitedTimeOfferEditor.vue?vue&type=script&lang=js"
import style0 from "./LimitedTimeOfferEditor.vue?vue&type=style&index=0&id=10cf2b0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cf2b0f",
  null
  
)

export default component.exports